import { BasicObject } from 'src/components/common/Types/CommonTypes';

export enum rateMasterMode {
  FCL = 'FCL', 
  LCL = 'LCL', 
  AIRCARGO = 'AIRCARGO',
  DOMESTIC = 'DOMESTIC',
  TRAILER = 'TRAILER',
  RPTL = 'RPTL',
} 

const { FCL, LCL, AIRCARGO, DOMESTIC, TRAILER, RPTL } = rateMasterMode

const categoryOptions: BasicObject[] = [
  { key: 'ORIGIN', label: 'Origin' },
  { key: 'DESTINATION', label: 'Destination' },
];

const freeDaysList: BasicObject[] = [
  { key: 'demurrageFreeDays', label: 'Demurrage Free Days' },
  { key: 'detentionFreeDays', label: 'Detention Free Days' },
];

const chargeCategoryoptions = {
  FREIGHT: 'Freight',
  LOCAL: 'Locals',
};

const ConfigureChargesText = (chargeCategory) => {
  return `Configure charges ${chargeCategory === 'FREIGHT' ? 'and cargo details' : ''}
    for your download sample`;
};

const uploadText = (step) => {
  return `${step} Your Excel File`;
};

const originDestinationPort = ['DRY', 'WET'];

const loadingPort = ['WET'];

const shippingModes = { FCL, LCL, AIR: AIRCARGO, TRAILER, DOMESTIC,  RPTL};

const weekDayMap = {
  s: 'Sunday',
  m: 'Monday',
  t: 'Tuesday',
  w: 'Wednesday',
  th: 'Thursday',
  f: 'Friday',
  sa: 'Saturday',
};

export const getDaysColumnModeWise = (mode: rateMasterMode) => {
  switch (mode) {
    case FCL:
      return {
        containerWeight: 'Container Weight',
        originFreeDays: 'Origin Free Days',
        cfsFreeDays: 'CFS Free Days',
        combinedFreeDays: 'Combined Free Days',
        demurrageFreeDays: 'Demurrage Free Days',
        detentionFreeDays: 'Detention Free Days',
      };
    case LCL:
      return {
        cfsFreeDays: 'CFS free days',
      };
    case AIRCARGO:
      return {
        demurrageFreeDays: 'Demurrage Free Days',
        detentionFreeDays: 'Detention Free Days',
      };
    default:
      return {};
  }
};

export {
  categoryOptions,
  freeDaysList,
  chargeCategoryoptions,
  ConfigureChargesText,
  uploadText,
  originDestinationPort,
  loadingPort,
  shippingModes,
  weekDayMap,
};
